import React from "react";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext/AuthContext";
import TextField from "../../components/Input/TextField";
import Button from "../../components/Button/Button";
import Alert from "../../components/Alert/Alert";
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo/logo-completo.png';
import imagenLogin from '../../assets/login/imagenLogin.png';

//TODO: si el token espina tengo que redirigir a la pagina de login

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const [alert, setAlert] = useState(false);
  
  const { token, login } = useContext(AuthContext);

  useEffect(() => {
    if (token) {
      navigate("/home");
    }
  }, [token, navigate]);

  const handleLogin = async () => {
    const isEmailValid = isValidEmail(email);
    const isPasswordValid = password.trim() !== "";

    setEmailError(!isEmailValid);
    setPasswordError(!isPasswordValid);

    if (isEmailValid && isPasswordValid) {
      const success = await login(email, password);

      if (success) {
        navigate("/home");
      } else {
        setAlert(true);
      }
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setAlert(false);
    
    if (isValidEmail(value)) {
      setEmailError(false);
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setAlert(false);

    if (e.target.value.trim() !== "") {
      setPasswordError(false);
    }
  };

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="w-full flex items-center justify-center pt-3 pb-3 border-b-2 border-[#F4F5F7]">
        <img src={logo} alt="MiQuery Logo" width={150} />
      </div>
         
      <div className="flex flex-1">
        <div className="hidden bg-[#F5F9FF] lg:flex w-1/2 items-center justify-center">         
          <div>
            <h1 className="text-4xl text-[#000000] font-medium mb-2">
              Optimiza tu análisis de datos
            </h1>
            <h2 className="text-2xl text-gray-500 font-light">
              Consulta, filtra y visualiza con inteligencia.
            </h2>

            <img src={imagenLogin} alt="imagenLogin" className="w-full max-w-md mx-auto"/>
          </div>
        </div>

        <div className="flex w-full lg:w-1/2 items-center justify-center">
          <div className="w-full max-w-md flex flex-col space-y-10 px-6 md:px-0">
            <TextField 
              label="Email" 
              type="email" 
              value={email} 
              onChange={handleEmailChange}
              error={emailError}
              helperErrorText={emailError ? "Ingresa un email válido." : ""}
            />            
            
            <TextField 
              label="Contraseña" 
              type="password" 
              value={password}
              onChange={handlePasswordChange}
              error={passwordError}
              showPasswordToggle={true}
              helperErrorText={passwordError ? "Ingresa una contraseña válida." : ""}
            />
          
            {alert && <Alert 
                        text="Credenciales incorrectas." 
                        variant="filled" 
                        severity="error"
                        backgroundColor="rgb(253, 235, 234)"
                        color="#d32f2f"
                      />
            }

            <Button text="Ingresar" onClick={handleLogin} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
